import React, {Component} from 'react'
import {CampaignPreviewCard, CampaignView, EngagementSwitch, ConclusionCard} from 'dabbl-react-components'
import findIndex from "lodash/findIndex";
import {hideChatBox} from '../../shared/utils';

// Components

class PhonePreviewCampaign extends Component {

  constructor(props) {
    super(props)
    this.state = {
      activeEngagementId: false,
      brandName: '',
      feedText: '',
      feedImageURL: '',
      logoURL: '',
      conclusionText: '',
      conclusionBackgroundColor: '',
      valuePerUser: 0,
      engagements: [],
      usesImageForVideos: '',
      showQAAnswer: '',
      hideTotalValue:''
    }
    this.receiveMessage = this.receiveMessage.bind(this);
    this.origin = `${window.location.protocol}//${window.location.hostname + (window.location.port ? ':' + window.location.port : '')}`
    this.emptyEngagement = {
      firstDcmTag: undefined, 
      firstImageFileName: undefined, 
      firstImageId: undefined, 
      firstImageURL: undefined,
      secondDcmTag: undefined, 
      secondImageFileName: undefined, 
      secondImageId: undefined, 
      secondImageURL: undefined,
      videoFileName: undefined, 
      videoId: undefined, 
      videoURL: undefined,
      firstImageThumbnailURL: undefined, 
      secondImageThumbnailURL: undefined,
      name: undefined, 
      value: undefined, 
      correctAnswerId: undefined, 
      correctAnswerText: "", 
      offerCode: undefined,
      createdDate: undefined, 
      lastModifiedDate: undefined, 
      isDeleted: undefined
    };
  }

  componentDidMount() {
    window.addEventListener("message", this.receiveMessage, false);
    hideChatBox()
    setTimeout(() => {
      hideChatBox()
    }, 1000)
  }

  componentDidUpdate() {
    hideChatBox()
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.receiveMessage, false);
  }

  receiveMessage(event) {
    console.debug("PhonePreviewCampaign: receiveMessage(event)")
    // Do we trust the sender of this message?
    if (!event || event.origin !== this.origin || typeof event.data !== 'string')
      return;

    const data = {...JSON.parse(event.data)}
    if (!data || !data.activeEngagementId || !data.engagements) {
      return
    }
    const activeEngagementId = data.activeEngagementId
    const engagements = data.engagements
    const totalNumSteps = engagements.length
    const engagementIndex = findIndex(engagements, e => String(e.id) === String(activeEngagementId))
    const engagement = (engagementIndex >= 0) ? engagements[engagementIndex] : {}
    const progressPercent = (activeEngagementId === '__CONCLUSION__') ? 100 : (totalNumSteps === 0) ? 0 : (100 * (engagementIndex + 1) / totalNumSteps)
    // console.debug(data)
    this.setState(Object.assign(data, {progressPercent: progressPercent, engagements: [], tags: [], ...this.emptyEngagement, ...engagement}))
  }

  render() {
    const {
      activeEngagementId,
      brandName,
      logoURL,
      conclusionText,
      conclusionBackgroundColor,
      valuePerUser,
      feedText,
      feedImageURL,
      progressPercent,
      cta,
      hideTotalValue
    } = this.state;

    return (
      <div>
        <div id='chat-widget'></div>
        {(activeEngagementId === '__FEED__') && (
          <div className='PhonePreviewCampaign_PreviewCard'>
            <CampaignPreviewCard
              text={feedText}
              imgSrc={feedImageURL}
              brandName={brandName}
              totalValue={valuePerUser}
            />
          </div>
        )}

        {(activeEngagementId === '__CONCLUSION__') && (
          <div className='PhonePreviewCampaign'>
            <CampaignView progressPercent={progressPercent} key={Math.random()}>
              <ConclusionCard
                hideTotalValue={hideTotalValue}
                brandLogoUrl={logoURL}
                brandName={brandName}
                brandColor={conclusionBackgroundColor}
                completionText={conclusionText}
                totalValue={valuePerUser}
                useAnimation={false}
                cta={cta}
                skipRating={true}
              />
            </CampaignView>
          </div>
        )}

        {(activeEngagementId !== '__CONCLUSION__' && activeEngagementId !== '__FEED__') && (
          <div className='vertical-center PhonePreviewCampaign'>
            <CampaignView progressPercent={progressPercent} key={Math.random()}>
              <EngagementSwitch {...this.state}
                                onEngagementAnswered={(answer) => { }}
                                useAnimation={false}/>
            </CampaignView>
          </div>
        )}
      </div>
    )
  }
}

export default PhonePreviewCampaign





// WEBPACK FOOTER //
// ./src/routes/PhonePreviewCampaign/PhonePreviewCampaign.js